var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 583 583",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.903498,0,0,0.903549,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 644.222,
    height: 644.222,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10681,0,0,1.10675,-34.4247,-34.4434)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.861183,-1.06544e-16,2.14759e-16,0.861183,-777.342,-2561.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1276.68,3011.38C1090.82,3011.38 939.931,3162.27 939.931,3348.12C939.931,3533.98 1090.82,3684.87 1276.68,3684.87C1462.53,3684.87 1613.42,3533.98 1613.42,3348.12C1613.42,3162.27 1462.53,3011.38 1276.68,3011.38ZM1276.68,3057.82C1436.9,3057.82 1566.98,3187.9 1566.98,3348.12C1566.98,3508.34 1436.9,3638.42 1276.68,3638.42C1116.46,3638.42 986.379,3508.34 986.379,3348.12C986.379,3187.9 1116.46,3057.82 1276.68,3057.82Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.465039,-6.01098e-17,1.1597e-16,0.485859,-406.593,-1302.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1566.98,3348.12C1566.98,3187.8 1437,3057.82 1276.68,3057.82C1116.35,3057.82 986.379,3187.8 986.379,3348.12",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "84.11px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.465039,1.1961e-16,-1.72921e-16,-0.485859,1050.82,1946.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1566.98,3348.12C1566.98,3187.8 1437,3057.82 1276.68,3057.82C1116.35,3057.82 986.379,3187.8 986.379,3348.12",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "84.11px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoV3);
export default __webpack_public_path__ + "static/media/logo-v3.55d6bc84087849c9274bf8812a96652c.svg";
export { ForwardRef as ReactComponent };